<template>
    <div>
        <div class="new-list-wrap">
          <van-cell-group class="news-list-title">
              <van-cell  style="margin-bottom: 0.275rem !important;padding-bottom: 0.275rem !important;" value="村长甄选"  @click="handleNewZhen()"><img class="list-title" src="static/img/new/menu/cz-v2.png?v=1" /></van-cell>
          </van-cell-group> 
          <div class="new-list">
            <!--
            <div v-if="(newZhenSpecialQuery.zid == 13)" >              
               <div class="new-list-img" style="background-image:url(static/img/bg.png),url(static/img/service/list/01.jpg?v=1);" @click="displayServiceLexiang()">
                 <div class="new-list-title">乐享柳州味道</div>
               </div> 
            </div>
            -->
            <div v-for="(item,index) in newsSpecialList" :key="item.ID" >
              <!--
               <div v-if="(newZhenSpecialQuery.zid == 13 && index == 0)" class="new-list-img" :style="'background-image:url(static/img/bg.png),url(static/img/service/list/01.jpg?v=1);'" @click="displayServiceLexiang()">
                 <div class="new-list-title">乐享柳州味道</div>                 
               </div> 
            -->
               
               
               <div class="new-list-img" :style="'background-image:url(static/img/bg.png),url('+item.thumbnail+');'" @click="displayArticle(item.ID,item.SID)">
                 <div class="new-list-title">{{item.LongTitle}}</div>
                 <img v-if="item.ico != 0" class="article-ico" :src="'static/img/ico/'+item.ico+'.png'"/>
               </div>      
            </div>
          </div>
        </div> 
        <div class="news-list-more" v-show="newsMoreVisible" @click="getPage">
          <van-loading class="maps-conents-loading" color="#222633" v-if="newsMoreLoading"/>
          <span v-if="!newsMoreLoading && newsSpecialList.length >= newZhenSpecialQuery.pageSize" >更多<img src="static/img/filter-down.png" class="news-list-more-down" /></span>
        </div>
   </div>
</template>
<script>
  import { Tabbar, TabbarItem, CellGroup } from 'vant';
  import { NavBar, Tab, Tabs, Search, Button, Field, Popup, Tag } from 'vant';
  import qs from 'qs'; 
  import { List, Cell } from 'vant';
  import { Row, Col } from 'vant';
  import { Loading } from 'vant';
  import request from '@/utils/request' 
  import { Toast,Dialog,Icon  } from 'vant'
  import moment from 'moment'
  
  import SpecialAPI from '@/api/special'
  export default {
    name: 'more',
    components: {   
      'van-cell-group':CellGroup, 
      'van-search': Search, 
      'van-icon':Icon,
      'van-field': Field, 
      'van-button': Button,
      'van-list': List,
      'van-cell': Cell,
      'van-tag': Tag,
      'van-col': Col,
      'van-row': Row,
      'van-loading':Loading
    },
    data() {
      return {
        //村长甄选
        newZhenListVisible:false,
        newZhenListY:'translateY(-100%)',
        newZhenListOpacity:0,
        newsSpecialList:[],
        newMenuY:'translateY(-100%)',
        newMenuVisible:false,
        newZhenSpecialQuery:{      
        zid:11,
        cid:0,
        pageIndex: 1,
        pageSize: 4        
        },      
        newsMoreVisible:true,
        newsMoreLoading:false,
        //特殊需求
        zid13LastData:'',
      }
    },
    props:['id'],
    watch: {
      id:function(val){
        this.newZhenSpecialQuery.zid = val
      },
    },
    mounted() {
    },
    created() {  
    },
    methods: { 
      getFirstPage(){
        let vm  = this
        if( this.newsSpecialList.length == 0 && this.newZhenSpecialQuery.pageIndex == 1){
          this.c('','getFirstPage')
          vm.newsMoreLoading = true
          setTimeout(function(){            
            vm.getPage()
          },500)          
        }
      },
      getPage(){
        if( this.newZhenSpecialQuery.pageIndex >1 ){
          this.newZhenSpecialQuery.pageSize = 4
          let eventName = ''
          if(this.id == 11){
            eventName = '鲜料'
          } else  if(this.id == 12){
            eventName = '趣玩'
          } else  if(this.id == 13){
            eventName = '服务'
          }
          _czc.push(['_trackEvent', '《'+eventName+'》板块', '点击','“村长甄选”->“更多”按钮','5',this.id]);
        } else {
          this.newZhenSpecialQuery.pageSize = 8
        }
        this.newZhenSpecialQuery.zid = this.id
        //TODO
        //乐享有BUG，第四条不见了，因为被第一条代替了        
       // if(this.newZhenSpecialQuery.zid == 13 && this.newZhenSpecialQuery.pageIndex == 1) {
       //   this.newZhenSpecialQuery.pageSize = 3
       // }else{
        //  this.newZhenSpecialQuery.pageSize = 4
       // }
        //if(this.newsMoreLoading) return
        this.newsMoreLoading = true
        SpecialAPI.getPage(this.newZhenSpecialQuery).then(response => {
              for(var i = 0; i < response.data.list.length; i++) {
                try {                
                   if(response.data.zid == 13 && response.data.pageIndex == 1 && i == 0) {
                    let data = {
                        "ID": 90001,
                        "star": 0,
                        "categoryName": "乐享柳州",
                        "LongTitle": "乐享柳州",
                        "ShortTitle": null,
                        "InStr": null,
                        "NewsForm": null,
                        "cid": 218,
                        "zid": 13,
                        "SID": 206,
                        "State": 0,
                        "ico":0,
                        "thumbnail": "static/img/service/list/01.jpg?v=1",
                      }
                      this.newsSpecialList.push(data);                         
                    } 
                    if(response.data.zid == 13 && response.data.pageIndex >1 && i == 0){  
                        this.newsSpecialList.push(this.zid13LastData);
                    }
                    if(response.data.zid == 13  && i == 3){                      
                      this.zid13LastData = response.data.list[i]
                    }else{                      
                      this.newsSpecialList.push(response.data.list[i]);
                    }
                }catch(e){
                  
                }
          }  
          if(response.data.list.length < this.newZhenSpecialQuery.pageSize){
            this.newsMoreVisible = false
          }          
          this.newsMoreLoading = false
          this.newZhenSpecialQuery.pageIndex++
        })
      },  
    displayArticle(id, type){      
        if(id == 90001){
          this.displayServiceLexiang()
          return
        }
        this.c("more.displayArticle","显示文章")
        let title = ''
        let surl = ''
        if(this.newZhenSpecialQuery.zid ==11){
          title = '鲜料'
          surl = '?view=1'
        } else if(this.newZhenSpecialQuery.zid==12){
          title = '趣玩'
          surl = '?view=3'
        } else if(this.newZhenSpecialQuery.zid==13){
          title = '服务'
          surl = '?view=4'
        }
        this.twohistory.push({title:title, shareurl:surl,desc:'',shareimg:''})
        this.c("this.firsthistory",this.firsthistory)
        
        for(let i = 0;i<this.newsSpecialList.length;i++){        
          if(this.newsSpecialList[i].ID == id){
            this.newsSpecialList[i].visits = this.newsSpecialList[i].visits + 1
          }
        }
        this.$parent.displayArticle(id, type)
    },
    displayServiceLexiang(){
      this.$parent.displayServiceLexiang()
    },
    handleNewZhen(){
      
    }
    } 
  }
</script>
<style scoped>
  .new-list-wrap {
    /*padding: 0.55rem 0.35rem;*/
    padding: 0.55rem 0.35rem 0 0.35rem;
    /* background-color: red; */
  }
  
  .new-title {
    width: 3.28rem;
    margin-top: 0.15rem;
    margin-left: 0.15rem;
  }
  
  .close-title {
    position: absolute;
    right: 5%;
    top: 24%;
    height: 29.3%;
    padding: 3%;
  }
  
  .new-list-wrap .van-hairline::after,
  .new-list-wrap .van-hairline--top-bottom::after,
  .new-menu .van-hairline--top-bottom::after,
  .new-menu .van-hairline::after,
  .new-menu[class*=van-hairline]::after {
    border: 0 solid #FFFFFF !important;
  } 
  
  /* 鲜料图片列表 */  
  .new-list {
    margin: 0 !important;
    /* background-color: royalblue; */
    display: flex;
        display: flex;
    flex-flow: row;
    flex-wrap: wrap;
  }
  
  .new-list>div {
    /* width: 3.31rem; */
    /* height: 2.52rem;
    display: inline-block;
    margin-bottom: -0.06rem; */
      width: 49%;
  }
  
  .new-list>div:nth-child(odd) {
    /* margin-right: 0.179rem; */
          margin-right: 2%;
  }
  
  .new-list img {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  
  
  /* 鲜料图片列表 end*/
  
  
  /* 甄选 */
  
  .new-list-img {
    position: relative;
    width: 100%;
    height: 2.52rem;
    float: left;
    margin-bottom: 0.179rem;
    margin-bottom: 4%;

    background-position: center;
    background-size: 100% 100%;
  }
  
  .new-list .article-ico {
    width: 36px!important;
    height: auto;
  }
  
  .new-list-title {
    position: absolute;
    width: 90%;
    height: 0.787rem;
    height: auto;
    left: 5%;
    bottom: 5%;
    color: #FFF;
    font-size: 0.3rem;
    font-weight: bold;
    letter-spacing: 2px;
    line-height: 0.40rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  
  .list-title {
    height: 0.34rem !important;
    /*53%!important;*/
    width: auto;
  }
  
  .view-main-warp .news-list-more {
    height: 0.78rem;
    line-height: 0.9rem;
    width: 100%;
    text-align: center;
    font-size: 0.32rem;
    border-top: 0.2rem solid #e8e9eb;
  }
  
  .view-main-warp .news-list-more-down {
    display: inline-block;
    width: 3.4%;
    margin-left: 5px;
    vertical-align: middle;
    transform: rotate(0deg) translateX(0px);
    -webkit-transform: rotate(0deg) translateX(0px);
    -webkit-transition: 250ms;
    transition: 250ms;
    transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
  }
  
  .maps-conents-loading {
    width: 10.56%;
    left: 44.54%;
    top: 40.26%;
  }
  
  .view-main-warp .new-menu .van-cell__value--alone {
    line-height: .0rem !important;
    overflow: visible;
  }
  
  .view-main-warp .new-list-wrap .van-cell__value--alone {
    padding: 0;
    line-height: 0rem !important;
  }
  
  .view-main-warp .newbao-list-wrap .van-cell__value--alone {
    height: calc(2.12rem + 0.09rem);
  }
  
  .view-main-warp .newbao-list-wrap .van-cell {
    height: 2.12rem;
    padding: 0;
    border-bottom: 0.09rem solid #e8e9eb;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/more.vue